module.exports = __webpack_public_path__ + "static/media/why-elite-nanny.64304e6f.jpg";